module.exports = __webpack_public_path__ + "img/av282.239f46d8.png";